module.exports = __webpack_public_path__ + "img/nordica.fdc5877f.svg";